<ng-container #content>
  <div class="send-business-card-modal">
    <div class="send-business-card-modal-wrapper">
      @if (closable) {
      <button mat-icon-button mat-dialog-close class="close-button">
        <mat-icon>close</mat-icon>
      </button>
      }
      <div class="send-business-card-modal-content">
        <bau365-shell-logo-dark class="send-business-card-modal-logo"></bau365-shell-logo-dark>
        <h4 i18n="@@uiModals-sendBusinessCard-headline" class="send-business-card-modal-header mat-headline-4"
          >Sie haben Fragen oder benötigen weitere Informationen?</h4
        >
        <ul>
          <li i18n="@@uiModals-sendBusinessCard-list-item-1">Digitale Visitenkarte übermitteln</li>
          @if (isBauInsights) {
          <li i18n="@@uiModals-confirmSendBusinessCard-list-item-2-insights">Vom Unternehmen kontaktiert werden</li>
          } @else {
          <li i18n="@@uiModals-confirmSendBusinessCard-list-item-2">Vom Aussteller kontaktiert werden</li>
          }
        </ul>
      </div>
    </div>
    <p class="send-business-card-modal-actions__hint">
      @if (reason==='isNotLoggedIn') {
      <ng-container i18n="@@uiModals-sendBusinessCard-info-isNotLoggedIn">
        Jetzt kostenlosen Account mit digitaler Visitenkarte erstellen, um diese Funktion zu nutzen.
      </ng-container>
      } @else if (reason==='hasNoBusinessCard') {
      <ng-container i18n="@@uiModals-sendBusinessCard-info-isNotLoggedIn">
        Jetzt digitale Visitenkarte erstellen, um diese Funktion zu nutzen.
      </ng-container>
      }
    </p>
    <div class="send-business-card-modal-actions">
      <div class="send-business-card-modal-actions__cancel">
        <button
          mat-flat-button
          mat-dialog-close
          color="secondary"
          class="send-business-card-modal-actions__cancel-button"
          i18n="@@uiModals-sendBusinessCard-cancelLabel">
          Abbrechen
        </button>
      </div>
      <div class="send-business-card-modal-actions__registration">
        @if (reason==='isNotLoggedIn') {
        <a
          [href]="registrationLink"
          mat-flat-button
          color="primary"
          class="send-business-card-modal-actions__registration-button"
          i18n="@@uiModals-sendBusinessCard-registerLinkLabel">
          Account erstellen
        </a>
        } @else if (reason==='hasNoBusinessCard') {
        <a
          [href]="redirectUri"
          mat-flat-button
          color="primary"
          class="send-business-card-modal-actions__registration-button"
          i18n="@@uiModals-sendBusinessCard-createBusinessCardLabel">
          Visitenkarte erstellen
        </a>
        }
      </div>
    </div>
    @if (reason==='isNotLoggedIn') {
    <div class="send-business-card-modal-footer">
      <ng-container i18n="@@uiModals-sendBusinessCard-footer-alreadyRegistered">
        Sie haben bereits einen Account?
      </ng-container>
      <a class="link" [href]="loginLink" i18n="@@uiModals-sendBusinessCard-footer-loginHere">Hier anmelden!</a>
    </div>
    }
  </div>
</ng-container>
